import { render, staticRenderFns } from "./PricingTable.vue?vue&type=template&id=d687344a&scoped=true"
import script from "./PricingTable.vue?vue&type=script&lang=js"
export * from "./PricingTable.vue?vue&type=script&lang=js"
import style0 from "./PricingTable.vue?vue&type=style&index=0&id=d687344a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d687344a",
  null
  
)

export default component.exports